import React, { useState, useEffect, useMemo, useCallback, useRef } from 'react';
import { Row, Col, Form, Input, Select, Upload, message, DatePicker, Spin, Drawer, Space, Modal, Popover } from 'antd';
import PropTypes from 'prop-types';
import ImgCrop from 'antd-img-crop';
import { Scrollbars } from 'react-custom-scrollbars';
import { Link, useHistory } from "react-router-dom";
import { CheckCircleOutlined } from '@ant-design/icons';
import FeatherIcon from 'feather-icons-react';
import { useDispatch, useSelector } from 'react-redux';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import moment from 'moment';
import InitialData from './InitialData.json'
import DetailsPage from './DetailsPage/Detailspage';
import TaskFields from './DetailsPage/TaskDetailsFields'
import RelatedTab from './DetailsPage/RelatedTab';
import TaskStatusBar from './DetailsPage/TaskStatusBar'
import TaskRightData from './DetailsPage/TaskRightData'
import { UploadUserTag, UserOwnerDetails } from './GlobalComponents/UserCardCmnts';
import { TaskRelatedItem, TaskRelatedItem1 } from './GlobalComponents/OtherCardCmnts'
import { RelatedDocUpload } from './GlobalComponents/RelatedDocUpload';
import { AddUser } from '../style';
import { getCasebuReportingUser, getFollowingCasebyUser, FetchCaseDetails } from '../../../Api/Services/CaseApiServices'
import { getAllUsersData } from '../../../Api/Services/CommonApiService'
import { TaskDeatailsApi, tasktypeApi, taskstatusApi, TasksSave, TaskUpdate } from '../../../Api/Services/TaskapiService';
import { FetchAllLead, LeadDetailData, FetchAllLeadByDep } from '../../../Api/Services/LeadApiServices';
import { FetchAllContact, FetchContactDetails, FetchAllContactByDep } from '../../../Api/Services/ContactApiService';
import { FetchAllAccount, FetchAccountDetails } from '../../../Api/Services/AccountApiService';
import { FetchAllDeal, PriorityDealApi, FetchDealDetails } from '../../../Api/Services/DealApiService';
import { useExcryptedNavigation, useNavigationDecrypted } from '../Filters/FilterConditions';
import { setEditCall } from '../../../redux/CrmReduxCalls/EditNavCtrl';
import { Main, BasicFormWrapper } from '../../styled';
import { Button } from '../../../components/buttons/buttons';
import { getBaseURL } from '../../../Api/ApiConfig'
import Heading from '../../../components/heading/heading';
import UpdateConnectionPopup from '../Popup/UpdateConnectionPopup';
import Popup from '../Popup/TAMassPopup'
import NotesPopup from '../Popup/NotesPopup'
import AllCancelPopup from '../Popup/AllCancelPopup';
import DefaultMessagePopup from '../Popup/DefaultMessagePopup'
import CallLogPopup from '../Popup/CallLogPopup'
import ComposeMail from '../Email/Compose';
import { CancelIcon, DeleteIcon, EditIcon, EmailIcon, NotesIcon, SaveIcon } from '../../../components/Icons/Icons';
import { nameOnChangeValidator, validateDescriptionField } from '../../../components/utilities/utilities';

const { Option } = Select;

function AddNew({ UrlId, FromPage, setCratePage, GetAll, CallBackTrigger, fromPageforTask, taskProp, CallBacksetStates, PreviousButton }) {
    const prevValues = useRef({ UrlId: "", FromPage: "" });
    const AutomationMessage = "Your action has triggered a business rule. Relevant validations, updates, or automated actions have been applied based on the configured logic."
    const { emailapiValues, emailactiontype } = useSelector((state) => state.EmailData);
    const dispatch = useDispatch();
    const [pages] = useState("Meeting")
    const localData = useSelector((state) => state.localRedux);
    const defaultCurrency = localData.currency
    const ProfileData = localData.profile
    const profile = ProfileData
    const companyProfile = localData.company
    const history = useHistory();
    const [form] = Form.useForm();
    const [edit, setEdit] = useState(false)
    const [users, setUsers] = useState([])
    const [NacTrigger, setNaCTrigger] = useState()
    const [dealPriority, setDealPriority] = useState([])
    const [taskId, setTaskId] = useState()
    const [popupMessage, setPopupMessage] = useState(false)
    const [displayData, setDisplayData] = useState()
    const [leadInitial, setLeadInitial] = useState()
    const [taskStatus, setTaskStatus] = useState()
    const [taskArrow, setTaskArrow] = useState([])
    const [allContactList, setAllContactList] = useState([])
    const [allLeadList, setAllLeadList] = useState([])
    const [allCompanyContact, setAllCompanyContact] = useState([])
    const [allCompanyLead, setAllCompabyLead] = useState([])
    const [allCaseList, setAllCaseList] = useState([])
    const [taskType, setTaskType] = useState()
    const [uiReady, setUiReady] = useState(false)
    const [typeId, setTypeId] = useState()
    const [FILEList, setFileList] = useState([]);
    const [typeNames, setTypeNames] = useState()
    const [fieldHide, setFieldHide] = useState(true)
    const [fromDisabled, setFromDisabled] = useState(false)
    const [lableName, setLableName] = useState()
    const [notePopup, setNotePopup] = useState(false)
    const [taskIDs, setTaskIDs] = useState()
    const [editField, setEditField] = useState(false)
    const [callLogPopup, setCallLogPopup] = useState(false)
    const [updatePopup, setUpdatePopup] = useState(false)
    const [popupType, setPopupType] = useState()
    const [dateTime, setDateTime] = useState(null);
    const [mailOpen, setMailOpen] = useState(false)
    const [page, setPage] = useState()
    const [uiReady2, setUiReady2] = useState(false)
    const [cancelConfirmOpen, setCancelConfirmOpen] = useState(false)
    const [errorData, setErrorData] = useState([])
    const [isModalVisible1, setIsModalVisible1] = useState(false)
    const [image, setImage] = useState()
    const [deleteOptions, setDeleteOpens] = useState(false);
    const [isAssigned, setIsAssigned] = useState(false)
    const [currencySettings, setCurrencySetting] = useState()
    const loadingRef = useRef(false);
    const [doubleClick, setDoubleClick] = useState(false)
    const [deleteClick, setDelteClick] = useState(false)
    const [states, setStates] = useState({
        selectedRows: [],
        selectedRowKeys: [],
    });
    const successMessage = (titles, data) => {
        const modal = Modal.success({
            className: "Glitter-MessagePopup",
            title: (
                <div style={{ display: 'flex', alignItems: 'center', gap: 5, justifyContent: "center" }}>
                    <CheckCircleOutlined style={{ color: 'green', fontSize: 20 }} />
                    <span>{titles}</span>
                </div>
            ),
            content: <p>{data}</p>,
            centered: true,
            okButtonProps: { style: { display: 'none' } },
            closable: true,
            onCancel: () => modal.destroy(),
        });
    }
    const PageCancel = () => {
        history.push('/Home/tasks')
    }
    const scroolup = () => {
        const currentPosition = window.scrollY;
        if (currentPosition > 0) {
            const scrollStep = Math.max(1, Math.ceil(currentPosition / 20));
            window.scrollTo(0, currentPosition - scrollStep);
            requestAnimationFrame(scroolup);
        }
    }
    const onnavigate = () => {
        history.push("/Home/email-config")
    }
    const { ExcryptedNavigation } = useExcryptedNavigation();
    const ViewDetailPage = (id, entity) => {
        ExcryptedNavigation("Nav", id, entity, history, null, null, null)
    }
    const normalizeValue = (value) => {
        if (value === undefined || value === "") return null;
        return value;
    };
    // Deep equality check (order-insensitive for objects)
    const isEqual = (a, b) => {
        if (a === b) return true;

        if (typeof a !== typeof b) return false;

        if (Array.isArray(a) && Array.isArray(b)) {
            if (a.length !== b.length) return false;
            return a.every((item, i) => isEqual(item, b[i]));
        }

        if (typeof a === "object" && a !== null && b !== null) {
            const keysA = Object.keys(a);
            const keysB = Object.keys(b);
            if (keysA.length !== keysB.length) return false;

            return keysA.every(key => isEqual(a[key], b[key]));
        }

        return false;
    };

    const getChangedFields = (newData, oldData) => {
        return Object.keys(newData).reduce((acc, key) => {
            if (!(key in oldData) || !isEqual(newData[key], oldData[key])) {
                acc[key] = newData[key];
            }
            return acc;
        }, {});
    };
    const GetPriorityDealApi = async () => {
        try {
            const data = await PriorityDealApi()
            const options = data.map((option, i) => (
                <Option value={option.priorityName} key={i} >
                    {option.priorityName}
                </Option>));
            setDealPriority(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function CreatorLedadListApi() {
        try {
            let Lead;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                Lead = await FetchAllLeadByDep()
            }
            else {
                Lead = await FetchAllLead()
            }
            setAllCompabyLead(Lead)
        }
        catch (error) {
            message.error(error)
        }
    }
    async function CreatorcontactListApi() {
        try {
            let contact;
            if (profile.department === "Customer Care" || profile.department === "Marketing") {
                contact = await FetchAllContactByDep()
            }
            else {
                contact = await FetchAllContact()
            }
            setAllCompanyContact(contact)
        }
        catch (error) {
            message.error(error)
        }
    }
    function convertAndFormatDateTime(dateTime, company, profile) {
        if (!dateTime || !company?.timeZone || !profile?.timeZone) return "";
        const extractTimezoneName = (tzStr) => {
            const match = tzStr.match(/\)\s*([A-Za-z/_]+)/);
            return match ? match[1] : "";
        };
        const fromTimezone = extractTimezoneName(company?.timeZone);
        const toTimezone = extractTimezoneName(profile?.timeZone);
        if (!moment.tz.zone(fromTimezone) || !moment.tz.zone(toTimezone)) {
            console.warn("Invalid timezone provided");
            return "";
        }
        const converted = moment.tz(dateTime, fromTimezone).tz(toTimezone)
        const dateFormat = profile?.dateFormate && profile?.dateFormate !== "" ? profile.dateFormate : "YYYY-MM-DD";
        const formattedDate = converted.format(dateFormat);
        return formattedDate
    }
    const RequiredDateFormating = (dateString) => {
        const parsedDate = moment(dateString, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
        const formattedDate = parsedDate.format("YYYY-MM-DD");
        return formattedDate;
    }
    const formatDateString = (dateString, format) => {
        return moment(dateString, "YYYY-MM-DD").format(format);
    };
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const AssignedCheck = (value) => {
        if (value.created_by === profile.userId) {
            setIsAssigned(true)
        }
        else if (value.task_owner === profile.userId) {
            setIsAssigned(true)
        }
        else if (value.assign_to === profile.userId) {
            setIsAssigned(false)
        }
        else {
            setIsAssigned(false)
        }
    }
    async function setInitialData(value) {
        setLeadInitial({
            taskTypeId: normalizeValue(value.task_type_id),
            taskName: normalizeValue(value.task_name),
            relatedToId: normalizeValue(value.related_to_id),
            taskProfile: normalizeValue(value.task_profile),
            taskOwner: normalizeValue(value.task_owner),
            dueDate: normalizeValue(value.due_date),
            taskStatusId: normalizeValue(value.task_status_id),
            priority: normalizeValue(value.priority),
            description: normalizeValue(value.description),
            assignTo: normalizeValue(value.assign_to),
            referenceDocument: (value.reference_document || []),
        })
    }
    const setData = (value) => {
        if (value !== undefined) {
            form.setFieldsValue({
                taskType: value.task_type_id,
                taskOwner: value.task_owner,
                status: value.task_status_id,
                priority: value.priority,
                name: value.related_to_id ? value.related_to_id.split(",").map(user => user * 1) : [],
                dueDate: value.due_date !== "" && value.due_date !== null ?
                    moment(formatDateString(value.due_date, profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"), profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD")
                    : null,
                description: value.description,
                assignTo: value.assign_to,
                taskName: value.task_name,
            })
            setTaskId(value.task_id)
            setFileList(value.reference_document || [])
            setLableName(value.task_type_name)
            setDateTime(value.due_date)
            setImage(value.task_profile)
            setDeleteOpens(value.task_profile && value.task_profile !== "")
            setStates({
                ...states,
                selectedRowKeys: [value.task_id]
            });
        }
    }
    async function getData(taskId) {
        try {
            const response = await TaskDeatailsApi(taskId)
            if (!response.allow) throw new Error();
            setData(response.data);
            setInitialData(response.data)
            const transformedItem = {
                ...response.data,
                created_at: response.data.created_at ? convertAndFormatDateTime(response.data.created_time ? `${response.data.created_at} ${response.data.created_time}` : response.data.created_at, companyProfile, profile) : "",
                modified_at: response.data.modified_at ? convertAndFormatDateTime(response.data.modified_time ? `${response.data.modified_at} ${response.data.modified_time}` : response.data.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
        } catch (error) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const CloseDrawer = () => {
        setCancelConfirmOpen(false)
        form.setFieldsValue({
            taskType: null,
            taskOwner: null,
            status: null,
            priority: null,
            name: [],
            dueDate: null,
            description: null,
            assignTo: null,
            taskName: null,
        })
        setFileList([])
        setLableName()
        setDateTime()
        setImage()
        setFromDisabled(false)
        setDeleteOpens(false)
        setStates({
            ...states,
            selectedRowKeys: []
        });
        if (FromPage !== "EntityUpdate" && fromPageforTask !== "FromDetails" && fromPageforTask !== "FromLisitng" && FromPage !== "Fromquery" && fromPageforTask !== "Fromquery") {
            GetAll();
            setCratePage();
        }
        if (fromPageforTask === "FromDetails" || fromPageforTask === "FromLisitng" || fromPageforTask === "Fromquery") {
            if (fromPageforTask === "FromLisitng") {
                CallBacksetStates({
                    selectedRows: [],
                    selectedRowKeys: [],
                })
            }
            if (fromPageforTask === "Fromquery") {
                CallBacksetStates()
            }
            setCratePage();
        }
        setIsAssigned(false)
        setEdit(false);
        setEditField(false);
        dispatch(setEditCall(false))
    }
    const CloseDrawerNew = () => {
        setCancelConfirmOpen(false)
        setEdit(false);
        setEditField(false);
        setIsAssigned(false)
        dispatch(setEditCall(false))
    }
    async function getData1(taskId, hideMessage, isAutomation, updateResponse) {
        try {
            const response = await TaskDeatailsApi(taskId)
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Task <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            if (!response.allow) throw new Error();
            setData(response.data);
            setInitialData(response.data)
            const transformedItem = {
                ...response.data,
                created_at: response.data.created_at ? convertAndFormatDateTime(response.data.created_time ? `${response.data.created_at} ${response.data.created_time}` : response.data.created_at, companyProfile, profile) : "",
                modified_at: response.data.modified_at ? convertAndFormatDateTime(response.data.modified_time ? `${response.data.modified_at} ${response.data.modified_time}` : response.data.modified_at, companyProfile, profile) : "",
            };
            setDisplayData(transformedItem)
            CloseDrawerNew()
        } catch (error) {
            hideMessage();
            loadingRef.current = false;
            setDoubleClick(false)
            if (isAutomation) {
                successMessage("Automation rule triggered", updateResponse.data[0].message);
            } else {
                message.success(
                    <span>
                        Task <strong>{updateResponse?.data?.[0]?.entityName}</strong> has been updated successfully
                    </span>
                );
            }
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    const { NavigationDecrypted } = useNavigationDecrypted();
    async function getEntityAvalibitlity() {
        let dataFound = true;
        try {
            const response = await NavigationDecrypted(UrlId[1])
            if (response) {
                setTaskId(response)
                dataFound = true;
                getData(response)
            }
            else {
                dataFound = false;
            }
        } catch (error) {
            dataFound = false;
        }
        if (!dataFound) {
            let secondsToGo = 3;
            const key = 'redirectCountdown';
            message.open({
                key,
                type: 'error',
                content: `This record is no longer available. It may have been deleted or moved`,
                duration: 0,
            });
            const interval = setInterval(() => {
                secondsToGo -= 1;
                if (secondsToGo === 0) {
                    clearInterval(interval);
                    message.destroy(key);
                    PageCancel();
                } else {
                    message.open({
                        key,
                        type: 'error',
                        content: `This record is no longer available. It may have been deleted or moved`,
                        duration: 0,
                    });
                }
            }, 1000);
        }
    }
    async function deleteMenu(id) {
        setTaskIDs([id])
        setUpdatePopup(true)
        setPopupType("Delete")
    }
    async function UserDetailsApi() {
        try {
            const data = await getAllUsersData()
            const options = data.map((option, i) => (
                <Option value={option.userId} key={i} label={(
                    <div style={{ display: 'flex', alignItems: 'center' }} >
                        <div className='Div_flex2'>
                            <div className='share_image' title={`${option.firstName} ${option.lastName} (${option.username})`} style={{ cursor: "default" }}>
                                {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                    < img src={option.profilePic} alt="profile" />
                                    :
                                    <span className="image_icon UserIcon">
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <span className='div-ellipsis'>{`${option.firstName} ${option.lastName}`}</span>
                            </div>
                        </div>
                    </div>
                )}>
                    <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.username})`}>
                        <div>
                            {option.profilePic !== null && option.profilePic !== undefined && option.profilePic !== "" ?
                                < img src={option.profilePic} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                :
                                <span className='details_span_Tag UserIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                    {option.firstName.slice(0, 1).toUpperCase()}
                                </span>
                            }</div>
                        <div>
                            <p style={{ fontWeight: 'bold', margin: 0 }}>{option.firstName} {option.lastName}</p>
                            <p style={{ margin: 0 }}>{option.username}</p>
                        </div>
                    </div>
                </Option>));
            setUsers(options)
        }
        catch (error) {
            message.error(error)
        }
    }
    const onchangeDelete = (value) => {
        if (value) {
            form.setFieldsValue({
                name: []
            })
        }
    }
    const handleTypeChange = async (value, option, displayData) => {
        if (value) {
            try {
                if (option.key === "Account") {
                    const allAccounts = await FetchAllAccount();
                    const accountMap = new Map(allAccounts.map(item => [item.account_id, item]));
                    if (displayData?.task_type_name === "Account") {
                        const relatedToIdString = displayData?.related_to_id || "";
                        const relatedIds = relatedToIdString
                            .split(',')
                            .map(id => Number(id))
                        const missingIds = relatedIds.filter(id => !accountMap.has(id));
                        if (missingIds.length > 0) {
                            const missingAccounts = await Promise.all(
                                missingIds.map(async (id) => {
                                    try {
                                        const responseData = await FetchAccountDetails(id);
                                        const account = responseData.data
                                        return account?.account_id ? account : null;
                                    } catch (error) {
                                        return null;
                                    }
                                })
                            );
                            missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.account_id, account); });
                        }
                    }
                    const fullAccountList = Array.from(accountMap.values());
                    const filterData = fullAccountList.filter((item) => item.account_type_name === "Customer").map((option, i) => (
                        <Option value={option.account_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.account_name} (${option.account_number})`}>
                                {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                    < img src={option.account_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag AccountIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.account_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                            </div>)}>
                            <div className='UserList-dropdown' title={`${option.account_name} (${option.account_number})`}>
                                <div>
                                    {option.account_profile !== null && option.account_profile !== undefined && option.account_profile !== "" ?
                                        < img src={option.account_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag AccountIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.account_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.account_name}</p>
                                    <p style={{ margin: 0 }}>{option?.account_number}</p>
                                </div>
                            </div>
                        </Option>));
                    setTypeNames(filterData)
                    setFieldHide(true)
                }
                else if (option.key === "Lead") {
                    const allAccounts = await FetchAllLead()
                    setAllLeadList(allAccounts)
                    const accountMap = new Map(allAccounts.map(item => [item.leads_id, item]));
                    if (displayData?.task_type_name === "Lead") {
                        const relatedToIdString = displayData?.related_to_id || "";
                        const relatedIds = relatedToIdString
                            .split(',')
                            .map(id => Number(id))
                        const missingIds = relatedIds.filter(id => !accountMap.has(id));
                        if (missingIds.length > 0) {
                            const missingAccounts = await Promise.all(
                                missingIds.map(async (id) => {
                                    try {
                                        const responseData = await LeadDetailData(id);
                                        const account = responseData.data
                                        return account?.leads_id ? account : null;
                                    } catch (error) {
                                        return null;
                                    }
                                })
                            );
                            missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.leads_id, account); });
                        }
                    }
                    const fullAccountList = Array.from(accountMap.values());
                    const options = fullAccountList.map((option, i) => (
                        <Option value={option.leads_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.firstName} ${option.lastName} (${option.primaryEmail})`}>
                                {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                                    < img src={option.lead_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag LeadIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.firstName} ${option.lastName}`}</p>
                            </div>)} >
                            <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.primaryEmail})`}>
                                <div>
                                    {option.lead_profile !== null && option.lead_profile !== undefined && option.lead_profile !== "" ?
                                        < img src={option.lead_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag LeadIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.firstName.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.firstName} ${option.lastName}`}</p>
                                    <p style={{ margin: 0 }}>{option?.primaryEmail}</p>
                                </div>
                            </div>
                        </Option>));
                    setTypeNames(options)
                    setFieldHide(true)
                }
                else if (option.key === "Contact") {
                    const allAccounts = await FetchAllContact()
                    setAllContactList(allAccounts)
                    const accountMap = new Map(allAccounts.map(item => [item.contacts_id, item]));
                    if (displayData?.task_type_name === "Contact") {
                        const relatedToIdString = displayData?.related_to_id || "";
                        const relatedIds = relatedToIdString
                            .split(',')
                            .map(id => Number(id))
                        const missingIds = relatedIds.filter(id => !accountMap.has(id));
                        if (missingIds.length > 0) {
                            const missingAccounts = await Promise.all(
                                missingIds.map(async (id) => {
                                    try {
                                        const responseData = await FetchContactDetails(id);
                                        const account = responseData.data
                                        return account?.contacts_id ? account : null;
                                    } catch (error) {
                                        return null;
                                    }
                                })
                            );
                            missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.contacts_id, account); });
                        }
                    }
                    const fullAccountList = Array.from(accountMap.values());
                    const options = fullAccountList.map((option, i) => (
                        <Option value={option.contacts_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.firstName} ${option.lastName} (${option.email})`}>
                                {option.contactProfile !== null && option.contactProfile !== undefined && option.contactProfile !== "" ?
                                    <img src={option.contactProfile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag ContactIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.firstName.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.firstName} ${option.lastName}`}</p>
                            </div>)} >
                            <div className='UserList-dropdown' title={`${option.firstName} ${option.lastName} (${option.email})`}>
                                <div>
                                    {option.contactProfile !== null && option.contactProfile !== undefined && option.contactProfile !== "" ?
                                        < img src={option.contactProfile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag ContactIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.firstName.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{`${option.firstName} ${option.lastName}`}</p>
                                    <p style={{ margin: 0 }}>{option?.email}</p>
                                </div>
                            </div>
                        </Option>));
                    setTypeNames(options)
                    setFieldHide(true)
                }
                else if (option.key === "Deal") {
                    const allAccounts = await FetchAllDeal()
                    const accountMap = new Map(allAccounts.map(item => [item.deals_id, item]));
                    if (displayData?.task_type_name === "Deal") {
                        const relatedToIdString = displayData?.related_to_id || "";
                        const relatedIds = relatedToIdString
                            .split(',')
                            .map(id => Number(id))
                        const missingIds = relatedIds.filter(id => !accountMap.has(id));
                        if (missingIds.length > 0) {
                            const missingAccounts = await Promise.all(
                                missingIds.map(async (id) => {
                                    try {
                                        const dealresponse = await FetchDealDetails(id);
                                        const account = dealresponse.data
                                        return account?.deals_id ? account : null;
                                    } catch (error) {
                                        return null;
                                    }
                                })
                            );
                            missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.deals_id, account); });
                        }
                    }
                    const fullAccountList = Array.from(accountMap.values());
                    const options = fullAccountList.map((option, i) => (
                        <Option value={option.deals_id} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.deal_name} (${option.pipelineStage})`}>
                                {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                    < img src={option.deal_profile} alt="profile" style={{ width: '20px', height: '20px', borderRadius: 20 }} />
                                    :
                                    <span className='details_span_Tag DealIcon' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                        {option.deal_name.slice(0, 1).toUpperCase()}
                                    </span>
                                }
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                            </div>)}>
                            <div className='UserList-dropdown' title={`${option.deal_name} (${option.pipelineStage})`}>
                                <div>
                                    {option.deal_profile !== null && option.deal_profile !== undefined && option.deal_profile !== "" ?
                                        < img src={option.deal_profile} alt="profile" style={{ width: '35px', height: '35px', borderRadius: 20 }} />
                                        :
                                        <span className='details_span_Tag DealIcon' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                            {option.deal_name.slice(0, 1).toUpperCase()}
                                        </span>
                                    }</div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.deal_name}</p>
                                    <p style={{ margin: 0 }}>{option?.pipelineStage}</p>
                                </div>
                            </div>
                        </Option>));
                    setTypeNames(options)
                    setFieldHide(true)
                }
                else if (option.key === "Case") {
                    const dataRaw = await getCasebuReportingUser()
                    const responseRaw = await getFollowingCasebyUser()
                    const data = dataRaw.map(item => ({ ...item, CaseLinkType: "CASE" }));
                    const response = responseRaw.map(item => ({ ...item, CaseLinkType: "FCASE" }));
                    const mergedCases = [
                        ...data,
                        ...response.filter(fc => !data.some(rc => rc.caseId === fc.caseId))
                    ];
                    setAllCaseList(mergedCases)
                    const accountMap = new Map(mergedCases.map(item => [item.caseId, item]));
                    if (displayData?.task_type_name === "Case") {
                        const relatedToIdString = displayData?.related_to_id || "";
                        const relatedIds = relatedToIdString
                            .split(',')
                            .map(id => Number(id))
                        const missingIds = relatedIds.filter(id => !accountMap.has(id));
                        if (missingIds.length > 0) {
                            const missingAccounts = await Promise.all(
                                missingIds.map(async (id) => {
                                    try {
                                        const account = await FetchCaseDetails(id);
                                        return account?.data.caseId ? account?.data : null;
                                    } catch (error) {
                                        return null;
                                    }
                                })
                            );
                            missingAccounts.filter(account => account !== null).forEach(account => { accountMap.set(account.caseId, account); });
                        }
                    }
                    const fullAccountList = Array.from(accountMap.values());
                    const options = fullAccountList.map((option, i) => (
                        <Option value={option.caseId} key={i} label={(
                            <div style={{ display: 'flex', alignItems: 'center', gap: 8 }} title={`${option.caseSubject} (${option.caseNumber})`}>
                                <span className='details_span_Tag' style={{ width: '20px', height: '20px', borderRadius: 20, fontSize: 14 }}>
                                    {option.caseSubject.slice(0, 1).toUpperCase()}
                                </span>
                                <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                            </div>)}>
                            <div className='UserList-dropdown' title={`${option.caseSubject} (${option.caseNumber})`}>
                                <div>
                                    <span className='details_span_Tag' style={{ width: '35px', height: '35px', borderRadius: 20, fontSize: 14 }}>
                                        {option.caseSubject.slice(0, 1).toUpperCase()}
                                    </span>
                                </div>
                                <div>
                                    <p style={{ fontWeight: 'bold', margin: 0 }}>{option.caseSubject}</p>
                                    <p style={{ margin: 0 }}>{option?.caseNumber}</p>
                                </div>
                            </div>
                        </Option>));
                    setTypeNames(options)
                    setFieldHide(true)
                }
                else {
                    setFieldHide(false)
                    setTypeNames([])
                }
                setTypeId(value);
                setLableName(option.key)
            }
            catch (error) {
                message.error(error)
            }
        }
        else {
            setTypeNames([])
        }
    }
    const TaskTypeApi = async () => {
        try {
            const data = await tasktypeApi()
            setTaskType(data)
            if (fromPageforTask === "FromDetails" || fromPageforTask === "FromLisitng" || fromPageforTask === "Fromquery") {
                if (taskProp) {
                    setFromDisabled(true)
                    const Values = data.find(item => item.taskTypeName === taskProp.type)
                    handleTypeChange(Values.taskTypeId, { key: Values.taskTypeName })
                    form.setFieldsValue({
                        taskType: Values.taskTypeId,
                        name: taskProp?.ids
                    })
                }
            } else {
                handleTypeChange(displayData.task_type_id, { key: displayData.task_type_name }, displayData)
            }
        } catch (error) {
            message.error(error)
        }
    }
    const TaskStatusApi = async () => {
        try {
            const data = await taskstatusApi()
            setTaskArrow(data)

            if (UrlId === undefined || UrlId === null || UrlId[0] !== "?TASK") {
                const Values = data.find(item => item.taskStatusName === "Not Started")
                form.setFieldsValue({
                    status: Values.taskStatusId
                })
            }
            const options = data.map((option) => (
                <Option value={option.taskStatusId} key={option.taskStatusName}>
                    {option.taskStatusName}
                </Option>));
            setTaskStatus(options)
        } catch (error) {
            message.error(error)
        }
    }
    const getUserDetail = async () => {
        if (UrlId === undefined || UrlId === null) {
            form.setFieldsValue({
                taskOwner: profile.userId
            });
        }
    }
    const fetchAll = async () => {
        await Promise.allSettled([
            GetPriorityDealApi(),
            TaskTypeApi(),
            UserDetailsApi(),
            CreatorLedadListApi(),
            CreatorcontactListApi(),
        ])
        setUiReady(true)
    };
    useEffect(() => {
        if (FromPage) {
            if (defaultCurrency) {
                setCurrencySetting(defaultCurrency);
            }
            scroolup()
            TaskStatusApi()
        }
    }, [FromPage])
    useEffect(() => {
        if (FromPage && editField && displayData) {
            fetchAll()
        }
    }, [FromPage, taskProp, fromPageforTask, editField, displayData])
    const handleNoteClick = (value) => {
        setNotePopup(true)
        setPopupType(value)
        setNaCTrigger("trigger")
        setPage("Entity")
    }
    useEffect(() => {
        const currentUrlId = JSON.stringify(UrlId); // <-- serialize for comparison
        const currentFromPage = FromPage;
        if (
            prevValues.current.UrlId === currentUrlId &&
            prevValues.current.FromPage === currentFromPage
        ) {
            return;
        }
        prevValues.current = {
            UrlId: currentUrlId,
            FromPage: currentFromPage,
        };
        if (FromPage) {
            if (FromPage === "EntityUpdate") {
                getEntityAvalibitlity()
            } else {
                form.setFieldsValue({
                    taskType: undefined,
                    taskOwner: undefined,
                    status: undefined,
                    priority: undefined,
                    name: [],
                    dueDate: undefined,
                    description: undefined,
                    assignTo: undefined,
                    taskName: undefined,
                })
                setTaskId()
                setFileList([])
                setLableName()
                setDateTime()
                setImage()
                setLeadInitial(InitialData.TaskData)
                setFromDisabled(false)
                setDeleteOpens(false)
                setDisplayData("Create")
                setEdit(true)
                setIsAssigned(true)
                setEditField(true)
                getUserDetail()
            }
        }
    }, [FromPage]);
    const closeMailComposr = () => {
        setMailOpen(false);
    };
    const CreateMail = () => {
        if (emailactiontype) {
            setPopupMessage(true)
        }
        else {
            setNaCTrigger("trigger")
            setMailOpen(true)
        }
    }
    const handleDateTimeChange = (date, dateString) => {
        const formattedDate = RequiredDateFormating(dateString)
        setDateTime(formattedDate);
    };
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const handleDeleteImages = () => {
        setImage(null);
        setDeleteOpens(false);
    };
    const FileUploads = {
        name: 'file',
        multiple: false,
        maxCount: 1,
        accept: 'image/*',
        action: `${getBaseURL()}/usermgmt/uploadFile`, // api for image upload
        onChange(info) {
            const { status } = info.file;
            if (status !== 'uploading') {
                // setState({ ...state, file: info.file, list: info.fileList });
            }
            if (status === 'done') {
                setImage(info.file.response.mediaUrl);// to set that image url
                setDeleteOpens(true)
                message.success(`${info.file.name} File upload successful`);
            } else if (status === 'error') {
                message.error(`${info.file.name} File upload failed`);
            }
        },
        listType: 'picture',
        showUploadList: false,
    };
    const urlPathname = window.location.pathname;
    const urlSearch = window.location.search;
    const combinedUrl = urlPathname + urlSearch;
    const handleEditChange = () => {
        setEditField(true)
        setEdit(true)
        dispatch(setEditCall(true))
        AssignedCheck(displayData);
        handleTypeChange(displayData.task_type_id, { key: displayData.task_type_name });
    }
    const moreAction = "No"
    const MoreAction = () => (<></>)
    const ButtonActions = [
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Send Email'
                onClick={() => CreateMail()}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        CreateMail()
                    }
                }}
                aria-label='mail'
            > <EmailIcon height={20} width={20} /></div>
        },
        {
            Actions: <div className='Hover-Refresh2 back-hover1 able-style'
                role="button"
                tabIndex={0} title='Add a Note'
                onClick={() => handleNoteClick("Create")}
                onKeyDown={(event) => {
                    if (event.key === 'Enter' || event.key === ' ') {
                        handleNoteClick("Create")
                    }
                }}
                aria-label='note'
            > <NotesIcon height={20} width={20} /></div>
        },
    ]
    const LeadInfos = {
        profile: image,
        Classname: "TaskIcon",
        letterIcon: displayData?.task_name,
        name: displayData?.task_name,
        subName: displayData?.task_status_name && displayData?.task_status_name !== "" ? displayData?.task_status_name : "Status",
        mainAction: undefined,
    }
    const memoUrlId = useMemo(() => (UrlId ? [UrlId[0], taskId] : null), [UrlId, taskId]);
    const getDetailsDatas = useCallback(() => getData(taskId), [taskId]);
    const UpdateDetails = (<TaskStatusBar UrlId={memoUrlId} getDetailsData={getDetailsDatas} leadStatusData={taskArrow} displayData={displayData} setNaCTrigger={setNaCTrigger} successMessage={successMessage} AutomationMessage={AutomationMessage} setErrorData={setErrorData} setIsModalVisible1={setIsModalVisible1} />)
    const LeadDetails = (<TaskFields ViewDetailPage={ViewDetailPage} displayData={displayData} />);
    const RelatedDetails = (<RelatedTab EntityType={displayData?.task_type_name === "Personal" ? "Task1" : "Task"} UrlId={memoUrlId} NacTrigger={NacTrigger} setNaCTrigger={setNaCTrigger} profile={profile} emailactiontype={emailapiValues} displayData={displayData} />)
    const RightRelatedDetails = (<TaskRightData displayData={displayData} />)
    const EditOpenForDrawer = () => {
        setEdit(true)
        dispatch(setEditCall(true))
    }
    const onSubmit = async (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDoubleClick(true)
        let hideMessage;
        const { assignTo,
            description,
            name,
            priority,
            status,
            taskName,
            taskOwner,
            taskType,
        } = values;
        const Name = name.join(',')
        const payload =
        {
            taskTypeId: normalizeValue(taskType),
            taskName: normalizeValue(taskName),
            relatedToId: Name,
            taskProfile: normalizeValue(image),
            taskOwner: normalizeValue(taskOwner),
            dueDate: normalizeValue(dateTime),
            taskStatusId: normalizeValue(status),
            priority: normalizeValue(priority),
            description: normalizeValue(description),
            assignTo: normalizeValue(assignTo),
            referenceDocument: FILEList
        }
        const updatedFields = getChangedFields(payload, leadInitial);
        if (Object.keys(updatedFields).length === 0) {
            getData(taskId)
            scroolup()
            message.success("Task updated")
            loadingRef.current = false;
            setDoubleClick(false)
            CloseDrawerNew()
            return;
        }
        try {
            hideMessage = message.loading("Loading...", 0);
            if (FromPage === "EntityUpdate") {
                const response = await TaskUpdate(updatedFields, taskId)
                if (response.status === 200) {
                    if (Array.isArray(response.data) && response.data.length > 0 && response.data[0].entityType !== 'Success') {
                        setErrorData(response.data);
                        setIsModalVisible1(true);
                        hideMessage();
                        loadingRef.current = false;
                        setDoubleClick(false)
                    }
                    else {
                        const isAutomation = response.data[0].message === AutomationMessage;
                        const ownerChanged = displayData.task_owner !== taskOwner;
                        if (ownerChanged) {
                            hideMessage()
                            if (isAutomation) {
                                successMessage("Automation rule triggered", response.data[0].message);
                            } else {
                                message.success(
                                    <span>
                                        Task <strong>{response?.data?.[0]?.entityName}</strong> has been updated successfully
                                    </span>
                                );
                            }
                            dispatch(setEditCall(false));
                            history.push('/Home/tasks')
                        }
                        else {
                            getData1(taskId, hideMessage, isAutomation, response)
                            scroolup()
                        }
                    }
                }
            }
            else {
                const response = await TasksSave(updatedFields)
                if (response.status === 201) {
                    const isAutomation = response?.data === AutomationMessage;
                    hideMessage();
                    dispatch(setEditCall(false))
                    if (fromPageforTask === "FromDetails") {
                        CallBackTrigger("CallBack")
                    }
                    if (isAutomation) {
                        successMessage("Automation rule triggered", response?.data);
                    } else {
                        message.success(response?.data);
                    }
                    loadingRef.current = false;
                    setDoubleClick(false)
                    CloseDrawer();
                }
            }
        }
        catch (error) {
            loadingRef.current = false;
            setDoubleClick(false)
            hideMessage();
            message.error(error)
        }
    }
    useEffect(() => {
        if (typeNames != null) {
            setUiReady2(true);
        }
    }, [typeNames]);
    const CloseDrawer2 = () => {
        scroolup();
        getData(taskId)
        setEditField(false)
        setEdit(false);
        setIsAssigned(false)
        dispatch(setEditCall(false))
    }
    const PageCancel1 = () => {
        if (FromPage === "EntityUpdate") {
            CloseDrawer2()
        }
        else {
            setCancelConfirmOpen(true)
        }
    }
    const FooterContent = ((uiReady && uiReady2 && edit) ? [
        fromPageforTask === "Fromquery" ?
            <div style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                margin: "50px 0px 0px"
            }}>
                <Button size="small"
                    className="gray-button" onClick={() => PreviousButton()}>
                    <FeatherIcon icon="arrow-left" size={16} />
                    Previous
                </Button>
                <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()}>
                    <SaveIcon height={25} width={25} />{FromPage === "EntityUpdate" ? "Update" : "Save"}
                </Button>
            </div> :
            <div className="form_action_button">
                <Button
                    className="gray-button" size="small"
                    onClick={() => PageCancel1()}
                >
                    <CancelIcon height={25} width={25} />Cancel
                </Button>
                {FromPage === "EntityUpdate" ? isAssigned ?
                    <Button className="red-button" size="small"
                        onClick={() => deleteMenu(taskId)} disabled={deleteClick || doubleClick} loading={deleteClick}
                    >
                        {!deleteClick && <DeleteIcon height={25} width={25} />}Delete
                    </Button> : <></> : <></>}
                <Button size="small" htmlType="submit" className="button_colors" onClick={() => form.submit()} disabled={deleteClick || doubleClick} loading={doubleClick}>
                    {!doubleClick && <SaveIcon height={25} width={25} />}{FromPage === "EntityUpdate" ? "Update" : "Save"}
                </Button>
            </div>
    ] : false)
    const PageContent = (
        <AddUser>
            <div className="user-info-form">
                <Form style={{ width: '100%' }} form={form} name="info" onFinishFailed={onFinishFailed} onFinish={onSubmit} colon={false}>
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div style={{ margin: fromPageforTask === "Fromquery" ? 0 : 40 }}>
                                <Row gutter={15}>
                                    <Col xs={24}>
                                        <div className="add-product-content">
                                            <Heading as="h5">Task Information</Heading>
                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Task Name" name="taskName"
                                                        id="taskName" rules={edit && isAssigned ? [{ required: true, message: 'Please enter task name' }, {
                                                            validator: (_, value) => {
                                                                const error = nameOnChangeValidator(value, 50);
                                                                if (error) {
                                                                    return Promise.reject(new Error(error));
                                                                }
                                                                return Promise.resolve();
                                                            },
                                                        }] : [{ required: false }]}>
                                                        {edit && isAssigned ? <Input placeholder='Enter Task Name' />
                                                            : <span >{displayData !== undefined && displayData.task_name}</span>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Task Owner" name="taskOwner"
                                                        id="taskOwner"
                                                        rules={edit && isAssigned ? [{ required: true, message: 'Please select a task owner', }] : [{ required: false }]}>
                                                        {edit && isAssigned ? <Select style={{ width: '100%' }} showSearch
                                                            optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }
                                                            } placeholder='Select Task Owner'>
                                                            {users}
                                                        </Select> :
                                                            <UserOwnerDetails record={{
                                                                recordbyFName: displayData?.taskOwner,
                                                                recordbyLName: null,
                                                                recordby: displayData?.task_owner,
                                                                recordbyProfilePic: displayData?.taskOwnerProfile
                                                            }} />
                                                        }
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Assignee" name="assignTo"
                                                        id="assignTo" rules={edit && isAssigned ? [{ required: true, message: 'Please select assignee', }] : [{ required: false }]}>
                                                        {edit && isAssigned ? <Select style={{ width: '100%' }} showSearch
                                                            optionLabelProp="label"
                                                            filterOption={(input, option) => {
                                                                const usernameElement = option.children.props.children[1].props.children[0];
                                                                if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                    const username = String(usernameElement.props.children);
                                                                    return username.toLowerCase().includes(input.toLowerCase());
                                                                }
                                                                return false;
                                                            }} placeholder='Select Assignee'>
                                                            {users}
                                                        </Select> :
                                                            <UserOwnerDetails record={{
                                                                recordbyFName: displayData?.assignTofirstName,
                                                                recordbyLName: displayData?.assignToLastName,
                                                                recordby: displayData?.assign_to,
                                                                recordbyProfilePic: displayData?.assignToProfilePic
                                                            }} />}
                                                    </Form.Item>
                                                </Col>
                                                {edit && <>
                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                        <Form.Item label="Related to" name="taskType"
                                                            id="taskType" rules={edit && isAssigned ? [{ required: true, message: 'Please select related to module', }] : [{ required: false }]}>
                                                            {edit && isAssigned ?
                                                                <Select style={{ width: '100%' }}
                                                                    disabled={fromDisabled}
                                                                    onChange={(value, option) => {
                                                                        handleTypeChange(value, option); onchangeDelete(value)
                                                                    }}
                                                                    value={typeId} placeholder='Select module'>
                                                                    {taskType !== undefined && taskType.map((option) => (
                                                                        <Option value={option.taskTypeId} key={option.taskTypeName}>
                                                                            {option.taskTypeName}
                                                                        </Option>))}
                                                                </Select>
                                                                : <span >{displayData !== undefined && displayData.task_type_name}</span>}
                                                        </Form.Item>
                                                    </Col>
                                                    {edit ? <>
                                                        <Col span={8} style={{ marginBottom: 20 }}>
                                                            <Form.Item
                                                                label=
                                                                {`${(lableName !== undefined && lableName !== null && lableName !== "" && lableName !== "Personal") ? `${lableName} Name` : `${lableName === "Personal" ? lableName : "Name"}`}`}
                                                                name="name"
                                                                id="name"
                                                                rules={edit && fieldHide && isAssigned ? [{ required: true, message: 'Please select name' }] : [{ required: false }]}>
                                                                {edit && isAssigned ?
                                                                    <Select style={{ width: '100%' }} mode="multiple" disabled={!fieldHide || fromDisabled}
                                                                        placeholder={lableName === "Personal" ? lableName : "Select Name"} optionLabelProp="label"
                                                                        optionFilterProp="children"
                                                                        filterOption={(input, option) => {
                                                                            const usernameElement = option.children.props.children[1].props.children[0];
                                                                            if (usernameElement && usernameElement.props && usernameElement.props.children) {
                                                                                const username = String(usernameElement.props.children);
                                                                                return username.toLowerCase().includes(input.toLowerCase());
                                                                            }
                                                                            return false;
                                                                        }
                                                                        }
                                                                    >
                                                                        {typeNames}
                                                                    </Select>
                                                                    : <>
                                                                        <div className='table_list_clicks' style={{
                                                                            display: 'flex',
                                                                            alignItems: 'center',
                                                                            flexWrap: "nowrap",
                                                                            minWidth: "max-content",
                                                                        }}>
                                                                            {displayData?.relatedToDetail && displayData?.relatedToDetail.length > 0 &&
                                                                                (<>
                                                                                    {displayData.relatedToDetail.slice(0, 3).map((item, index) => {
                                                                                        let permission;
                                                                                        if (displayData.task_type_name === "Account") { permission = item.entityPermission }
                                                                                        if (displayData.task_type_name === "Lead") { permission = item.entityPermission }
                                                                                        if (displayData.task_type_name === "Deal") { permission = item.entityPermission }
                                                                                        if (displayData.task_type_name === "Contact") { permission = item.entityPermission }
                                                                                        if (displayData.task_type_name === "Case") { permission = item.entityPermission }
                                                                                        return (
                                                                                            <TaskRelatedItem
                                                                                                displayData={displayData}
                                                                                                key={index}
                                                                                                item={item}
                                                                                                permission={{ isPresent: permission }}
                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                                currecny={currencySettings}
                                                                                                allCompanyContact={allCompanyContact}
                                                                                                allLeadList={allLeadList}
                                                                                                allContactList={allContactList}
                                                                                                allCompanyLead={allCompanyLead}
                                                                                                allCaseList={allCaseList}
                                                                                            />
                                                                                        )
                                                                                    })}
                                                                                    {displayData.relatedToDetail.length > 3 && (
                                                                                        <Popover
                                                                                            placement="bottomLeft"
                                                                                            trigger="hover"
                                                                                            content={
                                                                                                <div
                                                                                                    style={{
                                                                                                        maxHeight: "200px",
                                                                                                        overflowY: "auto",
                                                                                                        display: "flex",
                                                                                                        flexDirection: "column",
                                                                                                        gap: "8px",
                                                                                                        padding: "4px 0",
                                                                                                    }}
                                                                                                >
                                                                                                    {displayData.relatedToDetail.slice(3).map((item, index) => {
                                                                                                        let permission;
                                                                                                        if (displayData.task_type_name === "Account") { permission = item.entityPermission }
                                                                                                        if (displayData.task_type_name === "Lead") { permission = item.entityPermission }
                                                                                                        if (displayData.task_type_name === "Deal") { permission = item.entityPermission }
                                                                                                        if (displayData.task_type_name === "Contact") { permission = item.entityPermission }
                                                                                                        if (displayData.task_type_name === "Case") { permission = item.entityPermission }
                                                                                                        return (
                                                                                                            <TaskRelatedItem1
                                                                                                                displayData={displayData}
                                                                                                                key={index}
                                                                                                                item={item}
                                                                                                                permission={{ isPresent: permission }}
                                                                                                                ViewDetailPage={ViewDetailPage}
                                                                                                                currecny={currencySettings}
                                                                                                                allCompanyContact={allCompanyContact}
                                                                                                                allLeadList={allLeadList}
                                                                                                                allContactList={allContactList}
                                                                                                                allCompanyLead={allCompanyLead}
                                                                                                                allCaseList={allCaseList}
                                                                                                            />
                                                                                                        )
                                                                                                    })}
                                                                                                </div>
                                                                                            }
                                                                                        >
                                                                                            <span
                                                                                                style={{
                                                                                                    marginLeft: "25px",
                                                                                                    fontSize: "13px",
                                                                                                    fontWeight: 500,
                                                                                                    color: "#1677ff",
                                                                                                    cursor: "pointer",
                                                                                                }}
                                                                                            >
                                                                                                +{displayData.relatedToDetail.length - 3} more
                                                                                            </span>
                                                                                        </Popover>
                                                                                    )}
                                                                                </>
                                                                                )}
                                                                        </div>
                                                                    </>}
                                                            </Form.Item>
                                                        </Col>
                                                    </> : ""}
                                                </>}
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Due Date" name="dueDate"
                                                        id="dueDate" rules={edit && isAssigned ? [{ required: true, message: 'Please select a due date', }] : [{ required: false }]}>
                                                        {edit && isAssigned ?
                                                            <DatePicker
                                                                format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                                value={dateTime ? moment(dateTime, "YYYY-MM-DD") : null}
                                                                onChange={handleDateTimeChange}
                                                                disabledDate={disabledDate}
                                                                placeholder="Select date"
                                                            /> : <span >
                                                                {displayData !== undefined && displayData.due_date ? moment(displayData !== undefined && displayData.due_date).format(profile.dateFormate) : (displayData !== undefined && displayData.due_date && moment(displayData !== undefined && displayData.due_date).format("YYYY-MM-DD"))}
                                                            </span>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Status" name="status"
                                                        id="status" rules={edit ? [{ required: true, message: 'Please select status', }] : [{ required: false }]}>
                                                        {edit ? <Select style={{ width: '100%' }} placeholder='Select Task Status' >
                                                            {taskStatus}
                                                        </Select> : <span >{displayData !== undefined && displayData.task_status_name}</span>}
                                                    </Form.Item>
                                                </Col>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Priority" name="priority" initialValue={UrlId === undefined && "Low"}
                                                        id="priority">
                                                        {edit && isAssigned ? <Select allowClear style={{ width: '100%' }} onChange={(value) => form.setFieldsValue({ priority: value || null })} placeholder='Select Priority' >
                                                            {dealPriority}
                                                        </Select> : <span >{displayData !== undefined && displayData.priority}</span>}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                <Col span={24} style={{ marginBottom: 20 }}>
                                                    <Form.Item label="Description" name="description"
                                                        id="description" rules={
                                                            [
                                                                {
                                                                    validator: (_, value) => {
                                                                        const error = validateDescriptionField(value, 2500);
                                                                        if (error) {
                                                                            return Promise.reject(new Error(error));
                                                                        }
                                                                        return Promise.resolve();
                                                                    },
                                                                },
                                                            ]
                                                        }>
                                                        {edit ? <Input.TextArea rows={3} maxLength={2500} showCount placeholder='Enter Description' /> : <span >{displayData !== undefined && displayData.description}</span>}
                                                    </Form.Item>
                                                </Col>
                                            </Row>
                                            <RelatedDocUpload edit={edit} FILEList={FILEList} setFileList={setFileList} form={form} />
                                            <Heading as="h5">Profile Picture</Heading>
                                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                <Col span={8} style={{ marginBottom: 20 }}>
                                                    <figure className="photoUpload align-center-v" >
                                                        {image !== null && image !== undefined && image !== "" ?
                                                            < img src={image} alt="" />
                                                            :
                                                            UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK" ?
                                                                <span className='details_span_Tag TaskIcon'>
                                                                    {displayData?.task_name?.slice(0, 1).toUpperCase()}
                                                                </span>
                                                                :
                                                                <span className='details_span_Tag TaskIcon'>
                                                                    T
                                                                </span>}
                                                        {edit &&
                                                            <figcaption>
                                                                {deleteOptions ? (
                                                                    <div className='delete-div'>
                                                                        <span className='delete-span'>
                                                                            <FeatherIcon icon="trash-2" className="icon-svg" size={16} onClick={handleDeleteImages} />
                                                                        </span>
                                                                    </div>) :
                                                                    (<div>
                                                                        <ImgCrop aspect={1} cropShape="round" rotationSlider modalTitle="Crop Image">
                                                                            <Upload {...FileUploads}>
                                                                                <Link className="btn-upload" to={combinedUrl}>
                                                                                    <FeatherIcon icon="camera" size={16} />
                                                                                </Link>
                                                                            </Upload></ImgCrop>
                                                                    </div>)
                                                                }
                                                            </figcaption>
                                                        }
                                                    </figure>
                                                </Col>
                                            </Row>
                                            {UrlId !== undefined && UrlId !== null && UrlId[0] === "?TASK" && <>
                                                <Heading as="h5">Other Information</Heading>
                                                <Row gutter={30} style={{ margin: "20px 0px" }}>
                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                        <Form.Item label="Created Date" >
                                                            <span >{displayData?.created_at}</span>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                        <Form.Item label="Created By" >
                                                            <UploadUserTag record={{
                                                                uploadedBy: `${displayData?.createdByFirstName} ${displayData?.createdByLastName}`,
                                                                uploadedById: displayData?.created_by,
                                                                uploadedProfile: displayData?.createdByProfilePic
                                                            }} />
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                        <Form.Item label="Modified Date" >
                                                            <span >{displayData?.modified_at}</span>
                                                        </Form.Item>
                                                    </Col>
                                                    <Col span={8} style={{ marginBottom: 20 }}>
                                                        <Form.Item label="Modified By" >
                                                            <UploadUserTag record={{
                                                                uploadedBy: `${displayData?.modifiedByFirstName} ${displayData?.modifiedByLastName}`,
                                                                uploadedById: displayData?.modified_by,
                                                                uploadedProfile: displayData?.modifiedByProfilePic
                                                            }} />
                                                        </Form.Item>
                                                    </Col>
                                                </Row >
                                            </>}
                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form>
            </div>
        </AddUser>
    )
    return (
        <>
            {FromPage === "EntityUpdate" ?
                <Main>
                    {displayData ? <>
                        {FromPage === "EntityUpdate" &&
                            <DetailsPage PageCancel={PageCancel} handleEditChange={handleEditChange} UpdatePs={undefined} entity="Task" moreAction={moreAction}
                                DetailsPageMoreAction={<MoreAction />} ButtonActions={ButtonActions} Maincontent={LeadInfos} UpdateDataPage={UpdateDetails}
                                EntityTabDetails={LeadDetails} EntityRelatedTab={RelatedDetails} RightRelatedDetails={RightRelatedDetails}
                            />}
                    </>
                        :
                        <div className="spin">
                            <Spin />
                        </div>}
                </Main> : <></>}
            {fromPageforTask === "Fromquery" ? <>
                {(uiReady && uiReady2 && displayData) ? <div>
                    <div>{PageContent}</div>
                    <div> <Row gutter={15}>
                        <Col xs={24}>
                            <Row gutter={30} style={{ margin: "20px 0px" }}>
                                <Col span={23} style={{ marginBottom: 20 }}>
                                    {FooterContent}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                    </div>
                </div>
                    : <div className="spin">
                        <Spin />
                    </div>}</> : <Drawer
                        className='Drawer-Header-Pages'
                        bodyStyle={{ padding: 0 }}
                        title={
                            FromPage === "EntityUpdate" ?
                                <span>
                                    Update Task
                                    {displayData?.task_name && (
                                        <>
                                            <span style={{
                                                margin: '0 10px',
                                                color: '#d9d9d9',
                                                fontWeight: 'normal'
                                            }}>|</span>
                                            <span style={{ fontWeight: 'normal' }}>
                                                {displayData?.task_name}
                                            </span>
                                        </>
                                    )}
                                </span>
                                : "Create Task"
                        }
                        closable={false}
                        placement="right"
                        open={editField}
                        width="80%"
                        extra={
                            <Space>
                                {!edit ?
                                    <div className='Hover-Refresh2 back-hover1 able-style'
                                        role="button"
                                        tabIndex={0} title='Edit'
                                        onClick={() => EditOpenForDrawer()}
                                        onKeyDown={(event) => {
                                            if (event.key === 'Enter' || event.key === ' ') {
                                                EditOpenForDrawer()
                                            }
                                        }}
                                        aria-label='edit'
                                    > <EditIcon height={20} width={20} /></div> : <></>}
                                <div className='Hover-Refresh2 back-hover1 able-style'
                                    role="button"
                                    tabIndex={0} title='Close'
                                    onClick={() => PageCancel1()}
                                    onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            PageCancel1()
                                        }
                                    }}
                                    aria-label='Close'
                                > <CancelIcon width={24} height={24} /></div>
                            </Space>
                        }
                        footer={FooterContent}
                    >
                {(uiReady && uiReady2 && displayData) ? <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    {PageContent}
                </Scrollbars> :
                    <div className="spin">
                        <Spin />
                    </div>}
            </Drawer >}
            {isModalVisible1 && <UpdateConnectionPopup confirmPopup={isModalVisible1} setConfirmPopup={setIsModalVisible1} Respone={errorData} page="Details" type="Task" getCallBack={CloseDrawer2} />}
            {cancelConfirmOpen && <AllCancelPopup confirmPopup={cancelConfirmOpen} setConfirmPopup={setCancelConfirmOpen} GetCallback={CloseDrawer} />}
            <ComposeMail mailOpen={mailOpen} close={closeMailComposr} entityName="Tasks" entity="EntityPages" toId={[{ id: displayData?.assign_to, type: "User" }]} CallBackTrigger={setNaCTrigger} />
            {popupMessage && <DefaultMessagePopup messagePopup={popupMessage} setMessagePopup={setPopupMessage} pageType={pages} onNavigate={onnavigate} />}
            {updatePopup && <Popup updatePopup={updatePopup} setUpdatePopup={setUpdatePopup} taskIDs={taskIDs} popupType={popupType} AutomationMessage={AutomationMessage} successMessage={successMessage} setDoubleClick={setDelteClick} loadingRef={loadingRef} deleteClick={deleteClick} />}
            {notePopup && <NotesPopup setNotePopup={setNotePopup} notePopup={notePopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} page={page} />}
            {callLogPopup && <CallLogPopup setCallLogPopup={setCallLogPopup} callLogPopup={callLogPopup} popupType={popupType} UrlId={memoUrlId} setNaCTrigger={setNaCTrigger} />}
        </>
    );
}
AddNew.propTypes = {
    UrlId: PropTypes.array.isRequired,
    FromPage: PropTypes.string.isRequired,
    setCratePage: PropTypes.func.isRequired,
    CallBacksetStates: PropTypes.func.isRequired,
    GetAll: PropTypes.func.isRequired,
    CallBackTrigger: PropTypes.string.isRequired,
    fromPageforTask: PropTypes.string.isRequired,
    taskProp: PropTypes.object.isRequired,
    PreviousButton: PropTypes.func.isRequired,
};
export default AddNew;
